var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertUpperLimit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.724,
    height: 21.845,
    viewBox: "0 0 18.724 21.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up-to-line-solid",
    d: "M16.681,43.22l-5.988-5.988a1.884,1.884,0,0,0-2.662,0L2.043,43.22a1.655,1.655,0,0,0,1.17,2.823H6.241v6.241a1.559,1.559,0,0,0,1.56,1.56h3.121a1.559,1.559,0,0,0,1.56-1.56V46.043h3.028a1.655,1.655,0,0,0,1.17-2.823ZM1.56,35.121h15.6a1.56,1.56,0,1,0,0-3.121H1.56a1.56,1.56,0,1,0,0,3.121Z",
    transform: "translate(0 -32)",
    fill: "#9F555D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertUpperLimit);
export default __webpack_public_path__ + "static/media/alertUpperLimit.c8e69371fb49343287a54959768da146.svg";
export { ForwardRef as ReactComponent };